/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Einstellungen`
};

const en_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Settings`
};

const es_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Ajustes`
};

const fr_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Paramètres`
};

const it_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Impostazioni`
};

const nl_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Instellingen`
};

const pt_map_controls__aria_labels__settings = /** @type {(inputs: {}) => string} */ () => {
	return `Parâmetros`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__aria_labels__settings(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__aria_labels__settings", locale)
	if (locale === "de") return de_map_controls__aria_labels__settings(inputs)
	if (locale === "en") return en_map_controls__aria_labels__settings(inputs)
	if (locale === "es") return es_map_controls__aria_labels__settings(inputs)
	if (locale === "fr") return fr_map_controls__aria_labels__settings(inputs)
	if (locale === "it") return it_map_controls__aria_labels__settings(inputs)
	if (locale === "nl") return nl_map_controls__aria_labels__settings(inputs)
	return pt_map_controls__aria_labels__settings(inputs)
};